import * as React from "react";
const SvgFiRrCarBus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-bus_svg__a)">
      <path
        fill="#062147"
        d="M24 19a15.9 15.9 0 0 0-1.23-6.153l-.321-.77A4.99 4.99 0 0 0 17.833 9h-3.666a4.99 4.99 0 0 0-4.616 3.077l-.32.769c-.9 2.642-2.7 7.576.769 8.982V22a2 2 0 0 0 4 0h4a2 2 0 0 0 4 0v-.172A3 3 0 0 0 24 19m-12.6-6.154A2.99 2.99 0 0 1 14.167 11h3.666a2.99 2.99 0 0 1 2.77 1.846l.32.77c.054.127.1.255.154.384H10.924a14 14 0 0 1 .153-.385zM21 20H11c-1.757-.17-.77-2.869-.676-4H12v1a1 1 0 0 0 2 0v-1h4v1a1 1 0 0 0 2 0v-1h1.676c.093 1.129 1.081 3.831-.676 4M6.5 11H4V6.265c0-.089 0-.177.009-.265H9v1a1 1 0 0 0 2 0V6h4.991q.008.132.009.265V7a1 1 0 0 0 2 0v-.735A5.95 5.95 0 0 0 13.668.5a13.74 13.74 0 0 0-7.336 0A5.946 5.946 0 0 0 2 6.265V9a2 2 0 0 0 0 4v3a3.01 3.01 0 0 0 2 2.829V20a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1 1 1 0 0 1-1-1v-3h2.5a1 1 0 0 0 0-2m.355-8.568a11.7 11.7 0 0 1 6.29 0A3.83 3.83 0 0 1 15.313 4H4.687a3.83 3.83 0 0 1 2.168-1.568"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-bus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarBus;
